import { useLocation, Navigate,Outlet } from "react-router-dom";
import ROUTE from "../../common/Routes";
import { useSelector } from "react-redux";

const RequireAuth=({allowedRoles})=>{
     const userRole=useSelector(state=>state.userRoleRed)
   
    const location=useLocation();
    let isAllowPage=false;

 
    allowedRoles.forEach((item)=>{
        if(userRole.role === item){
            isAllowPage=true
        }
    })



    return (
        userRole.role
        ? isAllowPage === true? <Outlet /> :  <Navigate to={ROUTE.Home} state={{from:location}} replace />
        : <Navigate to={ROUTE.Login}  />
    );
}

export default RequireAuth;